import React from 'react'

import { UISkeleton, UISpacing } from 'components'

import * as S from './styles'

export const SkeletoIntro = () => (
  <>
    <S.IgnoreWidthPadding>
      <UISkeleton width="100%" height="265px" />
    </S.IgnoreWidthPadding>
    <UISpacing mb="lg" />
    <UISkeleton width="100%" height="29px" />
    <UISpacing mb="xxs" />
    <UISkeleton width="100%" height="29px" />
    <UISpacing mb="sm" />
    <UISkeleton width="100%" height="29px" />
    <UISpacing mb="md" />
    <UISkeleton width="100%" height="90px" />
    <UISpacing mb="lg" style={{ margin: 'auto' }} />
    <UISkeleton width="100%" height="48px" />
  </>
)
